import { DigitalSubscriptionAction } from './digital-subscription.action';

export class DigitalSubscriptionState {
    /**
     * Lista de produtos digitais do usuário
     */
    public purchases: any;
}

export const initialState: DigitalSubscriptionState = {
    purchases: null,
};

export function DigitalSubscriptionReducer(
    state: DigitalSubscriptionState = initialState,
    action?: DigitalSubscriptionAction,
): DigitalSubscriptionState {

    switch (action.type) {

        case DigitalSubscriptionAction.getPurchase:
            return { ...state, ...{ pending: true } };
        case DigitalSubscriptionAction.getPurchaseError:
            return { ...state, ...{ pending: false, error: action.payload, purchases: {} } };
        case DigitalSubscriptionAction.getPurchaseSuccess:
            return { ...state, ...{ pending: false, purchases: action.payload } };

        default:
            return state;
    }
}
